import { Component, Input, OnDestroy } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NzSelectPlacementType } from 'ng-zorro-antd/select';
import { copyToClipboard } from '../../utils/clipboard.util';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss'],
})
export class InputSelectComponent implements OnDestroy {
  @Input() placeholder: string = 'Select an option';
  @Input() isDisabled: boolean = false;
  @Input() label: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() multiSelection: boolean = false;
  @Input() size: 'default' | 'large' | 'small' = 'default';
  @Input() placement: NzSelectPlacementType = 'topLeft';
  @Input() options: any[] = [];
  @Input() optionsLabel: string = 'title';
  @Input() optionsValue: string = 'id';
  @Input() onChange: (value: any) => void = () => {};
  @Input() disabled: boolean = false;
  /** Shows a copy addon at the end of the select. */
  @Input() showCopy: boolean = false;

  public copied: boolean = false;
  private copiedTimer: any = null;

  selectionChanged(value: any): void {
    this.onChange(value);
  }

  ngOnDestroy() {
    clearTimeout(this.copiedTimer);
  }

  /** The visible label of the selected option(s), not the stored value. */
  copyText(): string {
    const value = this.control?.value;
    if (value === null || value === undefined || value === '') {
      return '';
    }

    if (Array.isArray(value)) {
      return value.map((item) => this.optionLabel(item)).join(', ');
    }

    return this.optionLabel(value);
  }

  copyValue(): void {
    const text = this.copyText();
    if (!text.trim()) {
      return;
    }

    copyToClipboard(text).then(() => {
      clearTimeout(this.copiedTimer);
      this.copied = true;
      this.copiedTimer = setTimeout(() => (this.copied = false), 1500);
    });
  }

  private optionLabel(value: any): string {
    const option = this.options?.find((item) => item[this.optionsValue] === value);
    return String(option?.[this.optionsLabel] ?? value);
  }

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
